import { axiosInstance } from "@/plugins/axios";
import {HSCode, RawHSCode} from "@/modules/hs_code/types";

export interface HSCodeFilter {
  search: null,
  offset: null,
  limit: null,
  orderBy: null,
  orderDesc: null
}

export interface UnsetHSCodeFilter {
  unset_hs_code_type: null,
  search: null,
  offset: null,
  limit: null,
  orderBy: null,
  orderDesc: null
}

export async function saveHSCode(hsCode: HSCode) {
  await axiosInstance.post(`harmonized_system_codes`, hsCode);
}

export async function getUnsetHSCodeItemsByType(unsetHSCodeType: UnsetHSCodeFilter) {
  let url = 'harmonized_system_codes/items/unset_type?';

  if (unsetHSCodeType.unset_hs_code_type) {
    url += `unset_hs_code_type=${unsetHSCodeType.unset_hs_code_type}`
  }

  if (unsetHSCodeType.limit) {
    url += `&offset=${unsetHSCodeType.offset}&limit=${unsetHSCodeType.limit}`;
  }

  if(unsetHSCodeType.search) {
    url+= `&search=${unsetHSCodeType.search}`;
  }

  if (unsetHSCodeType && unsetHSCodeType.orderBy !== '') {
    url += `&orderBy=${unsetHSCodeType.orderBy}&orderDesc=${unsetHSCodeType.orderDesc}`;
  }
  const response = await axiosInstance.get(url);
  return response.data;
}

export async function saveHSCodes(hsCodes: HSCode[]) {
  await axiosInstance.post(`harmonized_system_codes/create_or_update_many`, {
    excludedUSMCAHarmonizedSystemCodes: hsCodes
  });
}

export async function saveRawHSCodes(codes: RawHSCode[]) {
  return await axiosInstance.post(`harmonized_system_codes/raw/create_or_update_many`, {
    hsCodes: codes
  });
}

export async function getHSCodeTypeByCode(hsCode: HSCodeFilter) {
  let url = 'harmonized_system_codes/type?';

  if (hsCode.search) {
    url += `search=${hsCode.search}&`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
}

export async function getHSCodes(filter: HSCodeFilter) {
  let url = 'harmonized_system_codes/items?';

  if (filter.search) {
    url += `search=${filter.search}&`;
  }

  if (filter.offset) {
    url += `offset=${filter.offset}&`;
  }

  if (filter.limit) {
    url += `limit=${filter.limit}&`;
  }

  if (filter && filter.orderBy !== '') {
    url += `orderBy=${filter.orderBy}&orderDesc=${filter.orderDesc}`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
}

export async function getHSCodeTypes() {
  const url = 'harmonized_system_code_types/';
  const response = await axiosInstance.get(url);
  return response.data;
}
